// src/pages/ProductDetailPage.jsx - BENZER ÜRÜNLER CAROUSEL EKLENDİ
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
  ChevronRight, Heart, ShoppingCart, Minus, Plus,
  Star, Truck, Shield, RefreshCw, Share2, Check,
  Tag, Percent, Zap, Info, Play,
  MessageSquare, ThumbsUp, Image as ImageIcon,
  ChevronLeft
} from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { useSearch } from '../context/SearchContext';
import { getProductById, getAllProducts } from '../services/productService';
import { getAllCampaigns } from '../services/discountService';
import { getProductReviews, toggleReviewHelpful } from '../services/reviewService';
import { openCartSidebar } from '../components/CartSidebar';
import ProductCard from '../components/ProductCard';
import toast from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { trackPageView } from '../utils/analytics';

export default function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [reviewFilter, setReviewFilter] = useState('all');
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const [mediaTab, setMediaTab] = useState('images');
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  // 🆕 Benzer ürünler carousel için
  const relatedScrollRef = useRef(null);
  const [canScrollLeftRelated, setCanScrollLeftRelated] = useState(false);
  const [canScrollRightRelated, setCanScrollRightRelated] = useState(false);

  const { addToCart, isInCart, getItemQuantity, cartCount } = useCart();
  const { toggleWishlist, isInWishlist, wishlistCount } = useWishlist();
  const { searchQuery, setSearchQuery } = useSearch();

  const inCart = product ? isInCart(product.id) : false;
  const inWishlist = product ? isInWishlist(product.id) : false;
  const cartQuantity = product ? getItemQuantity(product.id) : 0;

  // 🆕 Benzer ürünler scroll kontrolü
  const checkRelatedScroll = () => {
    if (relatedScrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = relatedScrollRef.current;
      setCanScrollLeftRelated(scrollLeft > 0);
      setCanScrollRightRelated(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkRelatedScroll();
    const container = relatedScrollRef.current;
    if (container) {
      container.addEventListener('scroll', checkRelatedScroll);
      return () => container.removeEventListener('scroll', checkRelatedScroll);
    }
  }, [relatedProducts]);

  const scrollRelated = (direction) => {
    if (relatedScrollRef.current) {
      const scrollAmount = direction === 'left' ? -400 : 400;
      relatedScrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      try {
        const [productsResult, productResult, campaignsResult] = await Promise.all([
          getAllProducts(),
          getProductById(id),
          getAllCampaigns()
        ]);

        if (productResult.success) {
          setProduct(productResult.product);
          
          // ✅ KAMPANYALARI FİLTRELE - SÜRESIZ KAMPANYALARI DA DAHİL ET
          if (campaignsResult.success) {
            const now = new Date();
            
            const activeCampaigns = campaignsResult.campaigns.filter(campaign => {
              // ✅ Sadece discount tipindeki kampanyaları al
              if (campaign.discountType !== 'discount') {
                console.log('⏭️ ProductDetail - Kampanya atlandı (discount değil):', campaign.title);
                return false;
              }
              
              // ✅ Süresiz kampanya kontrolü
              if (!campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null) {
                console.log('✅ ProductDetail - Süresiz kampanya eklendi:', campaign.title);
                return true;
              }
              
              // ✅ Tarih kontrolü
              const endDate = new Date(campaign.endDate);
              const isActive = endDate > now;
              console.log(`📅 ProductDetail - ${campaign.title}: ${isActive ? 'Aktif' : 'Süresi dolmuş'}`);
              return isActive;
            });
            
            console.log('✅ ProductDetail - Aktif kampanyalar:', activeCampaigns.length);
            activeCampaigns.forEach(c => {
              console.log(`  - ${c.title}:`);
              console.log(`    Discount: ${c.discountPercent}%`);
              console.log(`    Category: ${c.targetCategory || 'Genel'}`);
              console.log(`    End Date: ${c.endDate || 'Süresiz'}`);
            });
            
            setCampaigns(activeCampaigns);
          }

          const reviewsResult = await getProductReviews(id);
          if (reviewsResult.success) {
            setReviews(reviewsResult.reviews || []);
          } else {
            setReviews([]);
          }

          const allResult = await getAllProducts();
          if (allResult.success) {
            const related = allResult.products
              .filter(p => p.category === productResult.product.category && p.id !== id)
              .slice(0, 8);
            setRelatedProducts(related);

            if (productsResult.success) {
              const activeProducts = productsResult.products.filter(product =>
                product.isActive !== false
              );
              setProducts(activeProducts);

              const categoriesSet = new Set();
              activeProducts.forEach(product => {
                if (product.category) {
                  const mainCat = product.category.includes(' > ')
                    ? product.category.split(' > ')[0]
                    : product.category;
                  categoriesSet.add(mainCat);
                }
              });
              setAvailableCategories(Array.from(categoriesSet));
            }
          }
        } else {
          toast.error('Ürün bulunamadı');
          navigate('/');
        }
      } catch (error) {
        console.error('❌ Fetch error:', error);
        toast.error('Bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
    trackPageView(`/product/${id}`, document.title);
    window.scrollTo(0, 0);
  }, [id, navigate]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const getApplicableCampaigns = () => {
    if (!product) return [];
    
    console.log('\n🎯 ===== getApplicableCampaigns (ProductDetail) =====');
    console.log('📦 Ürün:', product.name);
    console.log('📂 Kategori:', product.category);
    console.log('🎯 Toplam kampanya:', campaigns.length);
    
    const applicable = campaigns.filter(campaign => {
      console.log(`\n🔍 Kampanya: "${campaign.title}"`);
      
      // ✅ 1. Süresiz kampanya kontrolü
      if (!campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null) {
        console.log('  ♾️ Süresiz kampanya');
      } else {
        // ✅ 2. Tarih kontrolü
        const endDate = new Date(campaign.endDate);
        const now = new Date();
        const isActive = endDate > now;
        console.log(`  📅 Bitiş: ${campaign.endDate}`);
        console.log(`  ${isActive ? '✅' : '❌'} Aktif: ${isActive}`);
        
        if (!isActive) {
          console.log('  ❌ Kampanya süresi dolmuş, elendi');
          return false;
        }
      }
      
      // ✅ 3. Kategori kontrolü
      if (campaign.targetCategory && campaign.targetCategory !== '') {
        console.log(`  🎯 Hedef kategori: "${campaign.targetCategory}"`);
        
        // Ana kategori eşleşmesi
        const productMainCategory = product.category.includes(' > ')
          ? product.category.split(' > ')[0]
          : product.category;
        
        const campaignMainCategory = campaign.targetCategory.includes(' > ')
          ? campaign.targetCategory.split(' > ')[0]
          : campaign.targetCategory;
        
        console.log(`  📂 Ürün ana kategori: "${productMainCategory}"`);
        console.log(`  🎯 Kampanya ana kategori: "${campaignMainCategory}"`);
        
        const matches = productMainCategory === campaignMainCategory;
        console.log(`  ${matches ? '✅' : '❌'} Kategori eşleşmesi: ${matches}`);
        
        return matches;
      }
      
      // ✅ 4. Ürün ID kontrolü
      if (campaign.targetProducts && campaign.targetProducts.length > 0) {
        console.log(`  🎯 Hedef ürün ID'leri:`, campaign.targetProducts);
        const matches = campaign.targetProducts.includes(product.id);
        console.log(`  ${matches ? '✅' : '❌'} Ürün ID eşleşmesi: ${matches}`);
        return matches;
      }
      
      // ✅ 5. Genel kampanya
      console.log(`  🌍 Genel kampanya - tüm ürünler uygun`);
      return true;
    });
    
    console.log(`\n✅ Uygulanabilir kampanya sayısı: ${applicable.length}`);
    applicable.forEach(c => {
      console.log(`   - ${c.title} (%${c.discountPercent})`);
    });
    console.log('===== getApplicableCampaigns BİTTİ =====\n');
    
    return applicable;
  };

  const applicableCampaigns = getApplicableCampaigns();
  const bestCampaign = applicableCampaigns.length > 0
    ? applicableCampaigns.reduce((max, campaign) =>
      campaign.discountPercent > (max?.discountPercent || 0) ? campaign : max
    )
    : null;

  const calculateCampaignPrice = (campaign) => {
    if (!campaign || !product) return null;
    const discountedPrice = product.price * (1 - campaign.discountPercent / 100);
    return discountedPrice.toFixed(2);
  };

  const meetsMinimumPurchase = (offer) => {
    if (!offer.minPurchase) return true;
    return product.price * quantity >= offer.minPurchase;
  };

  const handleAddToCart = () => {
    addToCart(product, quantity);
    toast.success(`${quantity} adet ${product.name} sepete eklendi!`);
    setQuantity(1);
  };

  const handleBuyNow = () => {
    addToCart(product, quantity);
    navigate('/cart');
  };

  const handleShare = async () => {
    try {
      await navigator.share({
        title: product.name,
        text: product.description,
        url: window.location.href
      });
    } catch {
      navigator.clipboard.writeText(window.location.href);
      toast.success('Link kopyalandı!');
    }
  };

  const nextImage = () => {
    if (images.length > 0) {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (images.length > 0) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    }
  };

  const nextVideo = () => {
    if (videos.length > 0) {
      setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
    }
  };

  const prevVideo = () => {
    if (videos.length > 0) {
      setCurrentVideoIndex((prevIndex) =>
        prevIndex === 0 ? videos.length - 1 : prevIndex - 1
      );
    }
  };

  // 🆕 Dokunmatik slider için
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;

    const distance = touchStartX - touchEndX;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (mediaTab === 'images') {
      if (isLeftSwipe && images.length > 1) {
        nextImage();
      } else if (isRightSwipe && images.length > 1) {
        prevImage();
      }
    } else if (mediaTab === 'videos') {
      if (isLeftSwipe && videos.length > 1) {
        nextVideo();
      } else if (isRightSwipe && videos.length > 1) {
        prevVideo();
      }
    }
  };

  // 🆕 Yakınlaştırma fonksiyonu
  const handleImageMouseMove = (e) => {
    if (!isZoomed || !e.currentTarget) return;

    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomPosition({ x, y });
  };

  // 🆕 Thumbnail scroll fonksiyonu
  const thumbnailScrollRef = useRef(null);

  const scrollToThumbnail = (index) => {
    if (thumbnailScrollRef.current) {
      const thumbnails = thumbnailScrollRef.current.children;
      if (thumbnails[index]) {
        thumbnails[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  };

  useEffect(() => {
    setCurrentImageIndex(selectedImage);
  }, [selectedImage]);

  useEffect(() => {
    if (mediaTab === 'images') {
      scrollToThumbnail(currentImageIndex);
    } else if (mediaTab === 'videos') {
      scrollToThumbnail(currentVideoIndex);
    }
  }, [currentImageIndex, currentVideoIndex, mediaTab]);

  const handleHelpfulClick = async (reviewId) => {
    const userId = localStorage.getItem('userId') || 'guest';
    const result = await toggleReviewHelpful(reviewId, userId);

    if (result.success) {
      const reviewsResult = await getProductReviews(id);
      if (reviewsResult.success) setReviews(reviewsResult.reviews || []);
    }
  };

  if (loading) {
    return (
      <div className="product-detail-page loading">
        <Style />

        <Header
          wishlistCount={wishlistCount}
          cartCount={cartCount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSearch={handleSearch}
          onCartClick={openCartSidebar}
          onWishlistClick={() => navigate('/wishlist')}
          onCampaignsClick={() => navigate('/campaigns')}
          availableCategories={availableCategories}
          products={products}
        />

        <div className="container">
          <div className="loading-skeleton">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-line w-60"></div>
              <div className="skeleton-line w-80"></div>
              <div className="skeleton-line w-40"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!product) return null;

  const images = product.images && product.images.length > 0
    ? product.images
    : product.image
      ? [product.image]
      : [];

  const videos = product.videos && product.videos.length > 0
    ? product.videos
    : [];
  
  const campaignPrice = bestCampaign ? calculateCampaignPrice(bestCampaign) : null;
  const displayPrice = campaignPrice && meetsMinimumPurchase(bestCampaign) ? campaignPrice : product.price;

  // Rating statistics
  const activeReviews = reviews.filter(r => r.status === 'active' || !r.status);
  const hasReviews = activeReviews.length > 0;

  const ratingStats = {
    average: hasReviews && product.rating ? product.rating : 0,
    count: activeReviews.length,
    distribution: {
      5: activeReviews.filter(r => r.rating === 5).length,
      4: activeReviews.filter(r => r.rating === 4).length,
      3: activeReviews.filter(r => r.rating === 3).length,
      2: activeReviews.filter(r => r.rating === 2).length,
      1: activeReviews.filter(r => r.rating === 1).length
    }
  };

  const filteredReviews = reviewFilter === 'all'
    ? activeReviews
    : activeReviews.filter(r => r.rating === parseInt(reviewFilter));

  return (
    <div className="product-detail-page">
      <Style />

      <Header
        wishlistCount={wishlistCount}
        cartCount={cartCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        onCartClick={openCartSidebar}
        onWishlistClick={() => navigate('/wishlist')}
        onCampaignsClick={() => navigate('/campaigns')}
        availableCategories={availableCategories}
        products={products}
      />

      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Anasayfa</Link>
          <ChevronRight size={14} />

          {/* Kategori ayrıştırması */}
          {product.category && product.category.includes(' > ') ? (
            <>
              {/* Ana Kategori */}
              <Link to={`/category/${encodeURIComponent(product.category.split(' > ')[0])}`}>
                {product.category.split(' > ')[0]}
              </Link>
              <ChevronRight size={14} />

              {/* Alt Kategori */}
              <Link to={`/category/${encodeURIComponent(product.category)}`}>
                {product.category.split(' > ')[1]}
              </Link>
              <ChevronRight size={14} />
            </>
          ) : (
            <>
              {/* Tek seviye kategori */}
              <Link to={`/category/${encodeURIComponent(product.category)}`}>
                {product.category}
              </Link>
              <ChevronRight size={14} />
            </>
          )}

          <span>{product.name}</span>
        </div>

        <div className="product-layout">
          {/* 🆕 Medya Galerisi - Resim ve Video Desteği */}
          <div className="product-gallery">
            {/* 🆕 Medya Tab Seçici */}
            {videos.length > 0 && (
              <div className="media-tabs">
                <button
                  className={`media-tab ${mediaTab === 'images' ? 'active' : ''}`}
                  onClick={() => {
                    setMediaTab('images');
                    setCurrentImageIndex(0);
                  }}
                >
                  <ImageIcon size={16} />
                  Görseller ({images.length})
                </button>
                <button
                  className={`media-tab ${mediaTab === 'videos' ? 'active' : ''}`}
                  onClick={() => {
                    setMediaTab('videos');
                    setCurrentVideoIndex(0);
                  }}
                >
                  <Play size={16} />
                  Videolar ({videos.length})
                </button>
              </div>
            )}

            {/* Ana Medya Gösterimi */}
            <div
              className="main-image-slider"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {bestCampaign && meetsMinimumPurchase(bestCampaign) ? (
                <div className="discount-badge campaign-badge">
                  <Zap size={14} />
                  %{bestCampaign.discountPercent}
                </div>
              ) : product.discount > 0 ? (
                <div className="discount-badge">
                  <Percent size={14} />
                  %{product.discount}
                </div>
              ) : null}

              {/* 🆕 RESİM GÖSTERIMI */}
              {mediaTab === 'images' && (
                <>
                  {images.length > 1 && (
                    <>
                      <button
                        className="slider-nav-btn prev"
                        onClick={prevImage}
                        aria-label="Önceki görsel"
                      >
                        <ChevronLeft size={24} />
                      </button>

                      <button
                        className="slider-nav-btn next"
                        onClick={nextImage}
                        aria-label="Sonraki görsel"
                      >
                        <ChevronRight size={24} />
                      </button>

                      <div className="slider-counter">
                        {currentImageIndex + 1} / {images.length}
                      </div>
                    </>
                  )}

                  <div
                    className="main-image-container"
                    onMouseEnter={() => setIsZoomed(true)}
                    onMouseLeave={() => setIsZoomed(false)}
                    onMouseMove={handleImageMouseMove}
                  >
                    {images.length > 0 ? (
                      <>
                        <img
                          src={images[currentImageIndex]}
                          alt={`${product.name} ${currentImageIndex + 1}`}
                          className={isZoomed ? 'zoomed' : ''}
                          style={isZoomed ? {
                            transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                            transform: 'scale(2)'
                          } : {}}
                        />

                        {isZoomed && (
                          <div className="zoom-overlay">
                            <span className="zoom-hint">Yakınlaştırmak için üzerine gelin</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="no-image">
                        <ImageIcon size={64} />
                        <span>Görsel yok</span>
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* 🆕 VİDEO GÖSTERIMI */}
              {mediaTab === 'videos' && (
                <>
                  {videos.length > 1 && (
                    <>
                      <button
                        className="slider-nav-btn prev"
                        onClick={prevVideo}
                        aria-label="Önceki video"
                      >
                        <ChevronLeft size={24} />
                      </button>

                      <button
                        className="slider-nav-btn next"
                        onClick={nextVideo}
                        aria-label="Sonraki video"
                      >
                        <ChevronRight size={24} />
                      </button>

                      <div className="slider-counter">
                        {currentVideoIndex + 1} / {videos.length}
                      </div>
                    </>
                  )}

                  <div className="main-video-container">
                    <video
                      key={videos[currentVideoIndex]}
                      src={videos[currentVideoIndex]}
                      controls
                      className="main-video"
                      autoPlay={false}
                      preload="metadata"
                    >
                      Tarayıcınız video etiketini desteklemiyor.
                    </video>
                  </div>
                </>
              )}
            </div>

            {/* 🆕 THUMBNAIL SLIDER */}
            {((mediaTab === 'images' && images.length > 1) || (mediaTab === 'videos' && videos.length > 1)) && (
              <div className="thumbnail-slider">
                <div className="thumbnail-scroll-container" ref={thumbnailScrollRef}>
                  {mediaTab === 'images' && images.map((img, idx) => (
                    <button
                      key={idx}
                      className={`thumbnail ${idx === currentImageIndex ? 'active' : ''}`}
                      onClick={() => {
                        setCurrentImageIndex(idx);
                        setSelectedImage(idx);
                      }}
                      aria-label={`Görsel ${idx + 1}`}
                    >
                      <img src={img} alt={`${product.name} thumbnail ${idx + 1}`} />
                      {idx === currentImageIndex && (
                        <div className="thumbnail-active-indicator"></div>
                      )}
                    </button>
                  ))}

                  {mediaTab === 'videos' && videos.map((video, idx) => (
                    <button
                      key={idx}
                      className={`thumbnail video-thumb ${idx === currentVideoIndex ? 'active' : ''}`}
                      onClick={() => setCurrentVideoIndex(idx)}
                      aria-label={`Video ${idx + 1}`}
                    >
                      <video src={video} preload="metadata" />
                      <div className="video-thumb-overlay">
                        <Play size={20} />
                      </div>
                      {idx === currentVideoIndex && (
                        <div className="thumbnail-active-indicator"></div>
                      )}
                    </button>
                  ))}
                </div>

                {/* Thumbnail navigasyon */}
                {((mediaTab === 'images' && images.length > 5) || (mediaTab === 'videos' && videos.length > 5)) && (
                  <>
                    <button
                      className="thumbnail-nav prev"
                      onClick={() => {
                        if (thumbnailScrollRef.current) {
                          thumbnailScrollRef.current.scrollBy({
                            left: -100,
                            behavior: 'smooth'
                          });
                        }
                      }}
                      aria-label="Önceki thumbnail'lar"
                    >
                      <ChevronLeft size={16} />
                    </button>
                    <button
                      className="thumbnail-nav next"
                      onClick={() => {
                        if (thumbnailScrollRef.current) {
                          thumbnailScrollRef.current.scrollBy({
                            left: 100,
                            behavior: 'smooth'
                          });
                        }
                      }}
                      aria-label="Sonraki thumbnail'lar"
                    >
                      <ChevronRight size={16} />
                    </button>
                  </>
                )}
              </div>
            )}
          </div>

          {/* Ürün Bilgileri - Değişiklik Yok */}
          <div className="product-info">
            {/* Mevcut ürün bilgileri kodu aynı kalacak */}
            <div className="product-header">
              <span className="category-tag">{product.category}</span>
              <h1>{product.name}</h1>

              <div className="rating-row">
                {hasReviews ? (
                  <>
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={18}
                          fill={i < Math.floor(ratingStats.average) ? '#ffc107' : 'none'}
                          stroke="#ffc107"
                        />
                      ))}
                      <span className="rating-value">{ratingStats.average.toFixed(1)}</span>
                    </div>
                    <button
                      className="reviews-link"
                      onClick={() => setActiveTab('reviews')}
                    >
                      ({ratingStats.count} Değerlendirme)
                    </button>
                  </>
                ) : (
                  <span className="no-rating-text">Henüz değerlendirilmedi</span>
                )}
              </div>
            </div>

            <div className="price-section">
              {campaignPrice && meetsMinimumPurchase(bestCampaign) ? (
                <>
                  <span className="original-price">{product.price}₺</span>
                  <span className="current-price campaign-price">{campaignPrice}₺</span>
                  <span className="save-amount">
                    {(product.price - campaignPrice).toFixed(2)}₺ Kazanç
                  </span>
                </>
              ) : product.discount > 0 || (product.originalPrice && product.currentPrice && product.originalPrice > product.currentPrice) ? (
                <>
                  <span className="original-price">{(product.originalPrice || product.price).toFixed(2)}₺</span>
                  <span className="current-price">{(product.currentPrice || product.price).toFixed(2)}₺</span>
                  <span className="save-amount">
                    {((product.originalPrice || product.price) - (product.currentPrice || product.price)).toFixed(2)}₺ Kazanç
                  </span>
                </>
              ) : (
                <span className="current-price">{product.price?.toFixed(2)}₺</span>
              )}
            </div>

            {(applicableCampaigns.length > 0) && (
              <div className="offers-section">
                <h3>
                  <Tag size={16} />
                  Aktif Fırsatlar
                </h3>
                {applicableCampaigns.map(campaign => (
                  <div key={campaign.id} className="offer-card campaign-offer">
                    <div className="offer-header">
                      <div className="offer-badge campaign">
                        <Tag size={14} />
                        <span>KAMPANYA</span>
                      </div>
                      <div className="offer-discount">%{campaign.discountPercent}</div>
                    </div>
                    <div className="offer-body">
                      <h4>{campaign.title}</h4>
                      <p>{campaign.description}</p>
                      {campaign.minPurchase && (
                        <div className="offer-condition">
                          <Info size={12} />
                          <span>
                            Minimum {campaign.minPurchase}₺ alışveriş gereklidir
                            {!meetsMinimumPurchase(campaign) && (
                              <span className="warning"> (Şu an {(campaign.minPurchase - product.price * quantity).toFixed(2)}₺ eksik)</span>
                            )}
                          </span>
                        </div>
                      )}
                      {meetsMinimumPurchase(campaign) && (
                        <div className="offer-applied">
                          <Check size={14} />
                          <span>Sepette otomatik uygulanacak</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="actions-section">
              <div className="quantity-selector">
                <span>Adet:</span>
                <div className="quantity-controls">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                    <Minus size={16} />
                  </button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity(quantity + 1)}>
                    <Plus size={16} />
                  </button>
                </div>
              </div>

              <div className="action-buttons">
                <button
                  className={`add-to-cart-btn ${inCart ? 'in-cart' : ''}`}
                  onClick={handleAddToCart}
                >
                  {inCart ? <Check size={18} /> : <ShoppingCart size={18} />}
                  <span>{inCart ? `Sepette (${cartQuantity})` : 'Sepete Ekle'}</span>
                </button>

                <button className="buy-now-btn" onClick={handleBuyNow}>
                  Hemen Satın Al
                </button>
              </div>

              <div className="secondary-actions">
                <button
                  className={`wishlist-btn ${inWishlist ? 'active' : ''}`}
                  onClick={() => {
                    toggleWishlist(product);
                    toast.success(inWishlist ? 'Favorilerden çıkarıldı' : 'Favorilere eklendi');
                  }}
                >
                  <Heart size={18} fill={inWishlist ? '#E5332A' : 'none'} />
                  <span>{inWishlist ? 'Favorilerde' : 'Favorilere Ekle'}</span>
                </button>

                <button className="share-btn" onClick={handleShare}>
                  <Share2 size={18} />
                  <span>Paylaş</span>
                </button>
              </div>
            </div>

            <div className="features-list">
              <div className="feature">
                <Truck size={18} />
                <div>
                  <strong>Hızlı Teslimat</strong>
                  <span>1-3 iş günü içinde kargoda</span>
                </div>
              </div>
              <div className="feature">
                <Shield size={18} />
                <div>
                  <strong>Güvenli Ödeme</strong>
                  <span>256-bit SSL şifreleme</span>
                </div>
              </div>
              <div className="feature">
                <RefreshCw size={18} />
                <div>
                  <strong>Kolay İade</strong>
                  <span>7 gün içinde ücretsiz iade</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Details Tabs */}
        <div className="product-details-section">
          <div className="details-tabs">
            <button
              className={`tab ${activeTab === 'description' ? 'active' : ''}`}
              onClick={() => setActiveTab('description')}
            >
              Ürün Açıklaması
            </button>
            <button
              className={`tab ${activeTab === 'reviews' ? 'active' : ''}`}
              onClick={() => setActiveTab('reviews')}
            >
              Değerlendirmeler ({ratingStats.count})
            </button>
            <button
              className={`tab ${activeTab === 'specs' ? 'active' : ''}`}
              onClick={() => setActiveTab('specs')}
            >
              Özellikler
            </button>
          </div>

          <div className="details-content">
            {activeTab === 'description' && (
              <div className="description-tab">
                <h3>Ürün Hakkında</h3>
                <p>{product.description || 'Bu ürün için açıklama bulunmuyor.'}</p>
              </div>
            )}

            {activeTab === 'reviews' && (
              <ReviewsSection
                reviews={filteredReviews}
                ratingStats={ratingStats}
                reviewFilter={reviewFilter}
                setReviewFilter={setReviewFilter}
                onHelpfulClick={handleHelpfulClick}
                hasReviews={hasReviews}
              />
            )}

            {activeTab === 'specs' && (
              <div className="specs-tab">
                <h3>Teknik Özellikler</h3>
                <table className="specs-table">
                  <tbody>
                    <tr>
                      <td>Kategori</td>
                      <td>{product.category}</td>
                    </tr>
                    <tr>
                      <td>Marka</td>
                      <td>{product.brand || 'Genel'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* 🎯 Carousel ile Benzer Ürünler */}
        {relatedProducts.length > 0 && (
          <div className="related-products">
            <div className="section-header">
              <div>
                <h2>Benzer Ürünler</h2>
                <p>Aynı kategoriden diğer ürünler</p>
              </div>
            </div>

            <div className="products-carousel-wrapper">
              {canScrollLeftRelated && (
                <button
                  className="carousel-nav-btn left"
                  onClick={() => scrollRelated('left')}
                  aria-label="Önceki ürünler"
                >
                  <ChevronLeft size={24} />
                </button>
              )}

              <div className="products-carousel" ref={relatedScrollRef}>
                {relatedProducts.map(item => (
                  <div key={item.id} className="product-carousel-item">
                    <ProductCard
                      product={item}
                      campaigns={campaigns}
                    />
                  </div>
                ))}
              </div>

              {canScrollRightRelated && (
                <button
                  className="carousel-nav-btn right"
                  onClick={() => scrollRelated('right')}
                  aria-label="Sonraki ürünler"
                >
                  <ChevronRight size={24} />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

// Reviews Section Component
function ReviewsSection({ reviews, ratingStats, reviewFilter, setReviewFilter, onHelpfulClick, hasReviews }) {
  const userId = localStorage.getItem('userId') || 'guest';

  return (
    <div className="reviews-section">
      {!hasReviews ? (
        <div className="no-reviews-simple">
          <MessageSquare size={48} strokeWidth={1.5} color="#dee2e6" />
          <h3>Henüz Değerlendirme Yok</h3>
          <p>Bu ürün için henüz bir değerlendirme yapılmamış.</p>
        </div>
      ) : (
        <>
          <div className="rating-summary">
            <div className="rating-overview">
              <div className="rating-score">
                <div className="score-number">{ratingStats.average.toFixed(1)}</div>
                <div className="stars-large">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={24}
                      fill={i < Math.floor(ratingStats.average) ? '#ffc107' : 'none'}
                      stroke="#ffc107"
                      strokeWidth={2}
                    />
                  ))}
                </div>
                <div className="rating-count">{ratingStats.count} Değerlendirme</div>
              </div>

              <div className="rating-distribution">
                {[5, 4, 3, 2, 1].map(star => {
                  const count = ratingStats.distribution[star];
                  const percentage = ratingStats.count > 0
                    ? (count / ratingStats.count) * 100
                    : 0;

                  return (
                    <div key={star} className="rating-bar">
                      <span className="star-label">{star} <Star size={12} fill="#ffc107" stroke="none" /></span>
                      <div className="bar-container">
                        <div
                          className="bar-fill"
                          style={{
                            width: `${percentage}%`,
                            background: star >= 4 ? '#4CAF50' : star === 3 ? '#FF9800' : '#E5332A'
                          }}
                        />
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="reviews-filters">
            <div className="filter-buttons">
              <button
                className={`filter-btn ${reviewFilter === 'all' ? 'active' : ''}`}
                onClick={() => setReviewFilter('all')}
              >
                Tümü ({ratingStats.count})
              </button>
              {[5, 4, 3, 2, 1].map(star => {
                const count = ratingStats.distribution[star];
                if (count === 0) return null;
                return (
                  <button
                    key={star}
                    className={`filter-btn ${reviewFilter === star.toString() ? 'active' : ''}`}
                    onClick={() => setReviewFilter(star.toString())}
                  >
                    {star} <Star size={12} fill="#ffc107" stroke="none" /> ({count})
                  </button>
                );
              })}
            </div>
          </div>

          <div className="reviews-list">
            {reviews.length === 0 ? (
              <div className="no-reviews">
                <MessageSquare size={48} color="#dee2e6" />
                <p>Bu filtre için değerlendirme bulunamadı</p>
              </div>
            ) : (
              reviews.map(review => (
                <ReviewCard
                  key={review.id}
                  review={review}
                  userId={userId}
                  onHelpfulClick={onHelpfulClick}
                />
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}

// Review Card Component
function ReviewCard({ review, userId, onHelpfulClick }) {
  const isHelpful = review.helpfulUsers && review.helpfulUsers.includes(userId);

  return (
    <div className="review-card">
      <div className="review-header">
        <div className="reviewer-info">
          <div className="avatar">
            {review.userName?.[0]?.toUpperCase() || 'A'}
          </div>
          <div className="reviewer-details">
            <div className="reviewer-name">
              {review.userName || 'Anonim'}
              {review.isVerifiedPurchase && (
                <span className="verified-badge">
                  <Check size={12} />
                  Doğrulanmış Alışveriş
                </span>
              )}
            </div>
            <div className="review-meta">
              <div className="review-stars">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    fill={i < review.rating ? '#ffc107' : 'none'}
                    stroke="#ffc107"
                  />
                ))}
              </div>
              <span className="review-date">
                {review.createdAt ? new Date(review.createdAt).toLocaleDateString('tr-TR') : ''}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="review-content">
        {review.title && <h4 className="review-title">{review.title}</h4>}
        <p className="review-comment">{review.comment}</p>

        {review.images && review.images.length > 0 && (
          <div className="review-images">
            {review.images.map((img, idx) => (
              <div key={idx} className="review-image">
                <img src={img} alt={`Değerlendirme ${idx + 1}`} />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="review-footer">
        <button
          className={`helpful-btn ${isHelpful ? 'active' : ''}`}
          onClick={() => onHelpfulClick(review.id)}
        >
          <ThumbsUp size={16} fill={isHelpful ? '#2196F3' : 'none'} />
          Faydalı ({review.helpfulCount || 0})
        </button>

        {review.adminReply && (
          <div className="admin-reply">
            <div className="reply-badge">
              <Shield size={12} />
              Satıcı Yanıtı
            </div>
            <p>{review.adminReply.message}</p>
          </div>
        )}
      </div>
    </div>
  );
}

function Style() {
  return <style>{`
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Inter', -apple-system, sans-serif; }
    .product-detail-page { min-height: 100vh; background: #f8f9fa; }
    .container { max-width: 1320px; margin: 0 auto; padding: 0 20px; }
    
    /* BREADCRUMB */
    .breadcrumb { display: flex; align-items: center; gap: 6px; margin: 20px 0 20px; font-size: 13px; flex-wrap: wrap; }
    .breadcrumb a { color: #868e96; text-decoration: none; transition: color 0.2s; }
    .breadcrumb a:hover { color: #E5332A; }
    .breadcrumb span:last-child { color: #2B2B2B; font-weight: 500; }
    
    .product-layout { display: grid; grid-template-columns: 1fr 1.3fr; gap: 32px; background: #fff; border-radius: 16px; padding: 28px; margin-bottom: 32px; }
    
    /* Gallery */
    .product-gallery { position: sticky; top: 100px; }
    .main-image { position: relative; aspect-ratio: 1; border-radius: 12px; overflow: hidden; background: #fff; margin-bottom: 12px; border: 1px solid #e9ecef; }
    .main-image img { width: 100%; height: 100%; object-fit: contain; padding: 16px; }
    .discount-badge { position: absolute; top: 12px; left: 12px; background: #E5332A; color: #fff; padding: 5px 12px; border-radius: 8px; font-weight: 700; font-size: 13px; z-index: 2; display: flex; align-items: center; gap: 5px; }
    .campaign-badge { animation: pulse 2s infinite; }
    @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
    .thumbnail-list { display: flex; gap: 8px; }
    .thumbnail { width: 70px; height: 70px; border: 2px solid #e9ecef; border-radius: 8px; overflow: hidden; cursor: pointer; padding: 6px; background: #fff; transition: all 0.2s; }
    .thumbnail:hover { border-color: #E5332A; }
    .thumbnail.active { border-color: #E5332A; }
    .thumbnail img { width: 100%; height: 100%; object-fit: contain; }
    
    /* Product Info */
    .category-tag { display: inline-block; background: #f8f9fa; color: #868e96; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 5px; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.3px; }
    .product-info h1 { font-size: 22px; margin-bottom: 12px; line-height: 1.3; font-weight: 700; }
    
    /* RATING BÖLÜMÜ */
    .rating-row { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
    .stars { display: flex; align-items: center; gap: 3px; }
    .rating-value { margin-left: 6px; font-weight: 700; font-size: 15px; color: #2B2B2B; }
    .reviews-link { background: none; border: none; color: #2196F3; font-size: 14px; cursor: pointer; text-decoration: underline; padding: 0; transition: color 0.2s; }
    .reviews-link:hover { color: #1976D2; }
    .no-rating-text { color: #868e96; font-size: 14px; }
    
    .price-section { display: flex; align-items: baseline; gap: 12px; margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #e9ecef; flex-wrap: wrap; }
    .original-price { font-size: 17px; color: #868e96; text-decoration: line-through; }
    .current-price { font-size: 28px; font-weight: 800; color: #E5332A; }
    .current-price.campaign-price { animation: priceGlow 2s infinite; }
    @keyframes priceGlow { 0%, 100% { color: #E5332A; } 50% { color: #ff4436; } }
    .save-amount { background: #dcfce7; color: #16a34a; font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 6px; }

    /* Offers Section */
    .offers-section { background: #f8f9fa; padding: 18px; border-radius: 12px; margin-bottom: 24px; }
    .offers-section > h3 { display: flex; align-items: center; gap: 6px; font-size: 15px; margin-bottom: 14px; color: #2B2B2B; font-weight: 700; }
    .offer-card { background: #fff; border-radius: 10px; padding: 14px; margin-bottom: 10px; border: 2px solid transparent; transition: all 0.2s; }
    .offer-card:last-child { margin-bottom: 0; }
    .offer-card.campaign-offer { border-color: rgba(229, 51, 42, 0.15); }
    .offer-card.campaign-offer:hover { border-color: #E5332A; box-shadow: 0 3px 10px rgba(229, 51, 42, 0.1); }
    .offer-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
    .offer-badge { display: flex; align-items: center; gap: 5px; padding: 5px 10px; border-radius: 6px; font-size: 10px; font-weight: 700; letter-spacing: 0.3px; }
    .offer-badge.campaign { background: rgba(229, 51, 42, 0.1); color: #E5332A; }
    .offer-discount { font-size: 20px; font-weight: 800; color: #E5332A; }
    .offer-body h4 { font-size: 14px; font-weight: 700; margin-bottom: 5px; color: #2B2B2B; }
    .offer-body p { font-size: 13px; color: #495057; margin-bottom: 10px; line-height: 1.5; }
    .offer-condition { display: flex; align-items: flex-start; gap: 6px; padding: 8px 10px; background: #fff5f5; border-radius: 6px; font-size: 12px; color: #E5332A; margin-bottom: 6px; }
    .offer-condition svg { flex-shrink: 0; margin-top: 1px; }
    .offer-condition .warning { font-weight: 600; }
    .offer-applied { display: flex; align-items: center; gap: 6px; padding: 8px 10px; background: #dcfce7; border-radius: 6px; font-size: 12px; color: #16a34a; font-weight: 600; }
    .offer-applied svg { flex-shrink: 0; }
    
    /* Actions */
    .actions-section { margin-bottom: 24px; }
    .quantity-selector { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
    .quantity-selector > span { font-weight: 600; font-size: 14px; }
    .quantity-controls { display: flex; align-items: center; border: 2px solid #e9ecef; border-radius: 10px; }
    .quantity-controls button { width: 40px; height: 40px; border: none; background: none; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s; }
    .quantity-controls button:hover { background: #f8f9fa; }
    .quantity-controls button:active { transform: scale(0.95); }
    .quantity-controls > span { width: 40px; text-align: center; font-size: 16px; font-weight: 600; }
    
    .action-buttons { display: flex; gap: 10px; margin-bottom: 12px; }
    .add-to-cart-btn { flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px; background: #E5332A; color: #fff; border: none; padding: 14px 20px; border-radius: 12px; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
    .add-to-cart-btn:hover { background: #c72a22; }
    .add-to-cart-btn:active { transform: scale(0.98); }
    .add-to-cart-btn.in-cart { background: #06d6a0; }
    .buy-now-btn { flex: 1; background: #2B2B2B; color: #fff; border: none; padding: 14px 20px; border-radius: 12px; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
    .buy-now-btn:hover { background: #1a1a1a; }
    .buy-now-btn:active { transform: scale(0.98); }
    
    .secondary-actions { display: flex; gap: 10px; }
    .secondary-actions .wishlist-btn, 
    .secondary-actions .share-btn { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; background: none; border: 2px solid #e9ecef; padding: 10px; border-radius: 10px; font-weight: 600; font-size: 13px; cursor: pointer; transition: all 0.2s; }
    .secondary-actions .wishlist-btn:hover { border-color: #E5332A; color: #E5332A; }
    .secondary-actions .wishlist-btn.active { border-color: #E5332A; color: #E5332A; }
    .secondary-actions .share-btn:hover { border-color: #2B2B2B; }
    
    /* Features */
    .features-list { display: flex; flex-direction: column; gap: 12px; padding: 18px; background: #f8f9fa; border-radius: 12px; }
    .feature { display: flex; align-items: center; gap: 12px; }
    .feature svg { color: #E5332A; flex-shrink: 0; }
    .feature strong { display: block; font-size: 13px; }
    .feature span { font-size: 12px; color: #868e96; }

    /* PRODUCT DETAILS TABS */
    .product-details-section { background: #fff; border-radius: 16px; padding: 28px; margin-bottom: 32px; }
    .details-tabs { display: flex; gap: 4px; border-bottom: 2px solid #e9ecef; margin-bottom: 24px; }
    .details-tabs .tab { background: none; border: none; padding: 14px 24px; font-size: 15px; font-weight: 600; color: #868e96; cursor: pointer; position: relative; transition: all 0.2s; border-radius: 8px 8px 0 0; }
    .details-tabs .tab:hover { background: #f8f9fa; color: #2B2B2B; }
    .details-tabs .tab.active { color: #E5332A; background: #fff; }
    .details-tabs .tab.active::after { content: ''; position: absolute; bottom: -2px; left: 0; right: 0; height: 2px; background: #E5332A; }
    
    .details-content { min-height: 300px; }
    .description-tab h3 { font-size: 18px; margin-bottom: 16px; }
    .description-tab p { color: #495057; line-height: 1.8; font-size: 15px; }
    
    .specs-tab h3 { font-size: 18px; margin-bottom: 16px; }
    .specs-table { width: 100%; border-collapse: collapse; }
    .specs-table tr { border-bottom: 1px solid #e9ecef; }
    .specs-table tr:last-child { border-bottom: none; }
    .specs-table td { padding: 14px 16px; font-size: 14px; }
    .specs-table td:first-child { color: #868e96; font-weight: 600; width: 30%; }
    .specs-table td:last-child { color: #2B2B2B; }

    /* DEĞERLENDİRME YOK MESAJI */
    .no-reviews-simple { text-align: center; padding: 60px 20px; }
    .no-reviews-simple h3 { font-size: 20px; color: #2B2B2B; margin: 16px 0 8px; }
    .no-reviews-simple p { color: #868e96; font-size: 15px; }

    /* REVIEWS SECTION */
    .reviews-section { }
    
    .rating-summary { display: grid; grid-template-columns: 280px 1fr; gap: 32px; padding: 24px; background: #f8f9fa; border-radius: 12px; margin-bottom: 24px; align-items: center; }
    
    .rating-overview { display: flex; gap: 32px; align-items: center; }
    
    .rating-score { text-align: center; }
    .score-number { font-size: 48px; font-weight: 800; color: #2B2B2B; line-height: 1; margin-bottom: 8px; }
    .stars-large { display: flex; gap: 4px; justify-content: center; margin-bottom: 8px; }
    .rating-count { font-size: 14px; color: #868e96; }
    
    .rating-distribution { flex: 1; display: flex; flex-direction: column; gap: 8px; }
    .rating-bar { display: flex; align-items: center; gap: 12px; }
    .star-label { display: flex; align-items: center; gap: 4px; font-size: 14px; font-weight: 600; min-width: 50px; color: #2B2B2B; }
    .bar-container { flex: 1; height: 8px; background: #e9ecef; border-radius: 4px; overflow: hidden; }
    .bar-fill { height: 100%; transition: width 0.3s ease; border-radius: 4px; }
    .bar-count { font-size: 13px; color: #868e96; min-width: 40px; text-align: right; }
    
    .reviews-filters { margin-bottom: 24px; }
    .filter-buttons { display: flex; gap: 8px; flex-wrap: wrap; }
    .filter-btn { display: flex; align-items: center; gap: 4px; background: #fff; border: 2px solid #e9ecef; padding: 8px 16px; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: #495057; }
    .filter-btn:hover { border-color: #E5332A; color: #E5332A; }
    .filter-btn.active { background: #E5332A; border-color: #E5332A; color: #fff; }
    
    .reviews-list { display: flex; flex-direction: column; gap: 16px; }
    
    .no-reviews { text-align: center; padding: 60px 20px; display: flex; flex-direction: column; align-items: center; gap: 16px; }
    .no-reviews p { color: #868e96; font-size: 16px; }
    
    .review-card { background: #fff; border: 2px solid #e9ecef; border-radius: 12px; padding: 20px; transition: all 0.2s; }
    .review-card:hover { border-color: #dee2e6; box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
    
    .review-header { margin-bottom: 16px; }
    .reviewer-info { display: flex; gap: 12px; }
    .avatar { width: 48px; height: 48px; border-radius: 50%; background: #E5332A; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 20px; font-weight: 700; flex-shrink: 0; }
    .reviewer-details { flex: 1; }
    .reviewer-name { display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 700; color: #2B2B2B; margin-bottom: 6px; }
    .verified-badge { display: flex; align-items: center; gap: 4px; background: #dcfce7; color: #16a34a; font-size: 11px; font-weight: 600; padding: 3px 8px; border-radius: 6px; }
    .review-meta { display: flex; align-items: center; gap: 12px; }
    .review-stars { display: flex; gap: 2px; }
    .review-date { font-size: 13px; color: #868e96; }
    
    .review-content { margin-bottom: 16px; }
    .review-title { font-size: 16px; font-weight: 700; color: #2B2B2B; margin-bottom: 8px; }
    .review-comment { font-size: 14px; color: #495057; line-height: 1.7; }
    .review-images { display: flex; gap: 8px; margin-top: 12px; flex-wrap: wrap; }
    .review-image { width: 80px; height: 80px; border-radius: 8px; overflow: hidden; border: 2px solid #e9ecef; cursor: pointer; transition: all 0.2s; }
    .review-image:hover { border-color: #E5332A; transform: scale(1.05); }
    .review-image img { width: 100%; height: 100%; object-fit: cover; }
    
    .review-footer { display: flex; flex-direction: column; gap: 12px; }
    .helpful-btn { display: flex; align-items: center; gap: 6px; background: none; border: 2px solid #e9ecef; padding: 8px 16px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: #495057; width: fit-content; }
    .helpful-btn:hover { border-color: #2196F3; color: #2196F3; }
    .helpful-btn.active { background: #e3f2fd; border-color: #2196F3; color: #2196F3; }
    
    .admin-reply { background: #f8f9fa; border-left: 3px solid #E5332A; padding: 12px 16px; border-radius: 8px; }
    .reply-badge { display: flex; align-items: center; gap: 6px; color: #E5332A; font-size: 12px; font-weight: 700; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; }
    .admin-reply p { font-size: 14px; color: #495057; line-height: 1.6; }

    /* 🎯 YENİ: BENZER ÜRÜNLER CAROUSEL */
    .related-products { margin-bottom: 40px; }
    .section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; flex-wrap: wrap; gap: 16px; }
    .section-header h2 { font-size: 24px; font-weight: 800; }
    .section-header p { color: #868e96; font-size: 14px; }
    
    .products-carousel-wrapper { position: relative; }
    
    .products-carousel {
      display: flex;
      gap: 20px;
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding: 4px 0;
    }
    
    .products-carousel::-webkit-scrollbar { display: none; }
    
    .product-carousel-item {
      flex: 0 0 auto;
      width: calc((100% - 80px) / 5);
      min-width: 220px;
      height: 380px;
    }
    
    .carousel-nav-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.95);
      border: 2px solid #e9ecef;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    }
    
    .carousel-nav-btn:hover {
      background: #fff;
      border-color: #E5332A;
      box-shadow: 0 6px 20px rgba(229, 51, 42, 0.2);
    }
    
    .carousel-nav-btn:active {
      transform: translateY(-50%) scale(0.95);
    }
    
    .carousel-nav-btn.left {
      left: -24px;
    }
    
    .carousel-nav-btn.right {
      right: -24px;
    }
    
    .carousel-nav-btn svg {
      color: #2B2B2B;
      transition: color 0.3s ease;
    }
    
    .carousel-nav-btn:hover svg {
      color: #E5332A;
    }

    /* PRODUCT CARD */
    .product-card { background: #fff; border-radius: 12px; overflow: hidden; position: relative; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.04); transition: all 0.3s; height: 100%; display: flex; flex-direction: column; }
    .product-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
    
    /* Product Card içindeki Wishlist Butonu */
    .product-card .wishlist-btn { position: absolute; top: 8px; right: 8px; width: 32px; height: 32px; background: rgba(255,255,255,0.9); border: none; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; transition: all 0.2s; padding: 0; }
    .product-card .wishlist-btn:hover { background: #fff; transform: scale(1.1); }
    
    .product-image { width: 100%; aspect-ratio: 1; overflow: hidden; background: #f8f9fa; }
    .product-image img { width: 100%; height: 100%; object-fit: contain; transition: transform 0.4s; }
    .product-card:hover .product-image img { transform: scale(1.08); }
    .image-skeleton { width: 100%; height: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; }
    @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
    .product-info { padding: 12px; display: flex; flex-direction: column; flex: 1; }
    .product-brand { color: #868e96; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; }
    .product-desc { color: #2B2B2B; font-size: 0.8rem; margin-bottom: 0.75rem; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 2.2em; }
    .product-rating { display: flex; align-items: center; gap: 4px; font-size: 11px; margin-bottom: 10px; }
    .reviews { color: #868e96; }
    .product-footer { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: auto; }
    .product-price { display: flex; flex-direction: column; gap: 2px; flex: 1; }
    .old-price { color: #868e96; font-size: 11px; text-decoration: line-through; }
    .current-price { color: #E5332A; font-size: 16px; font-weight: 800; }
    .campaign-label { color: #E5332A; font-size: 8px; font-weight: 700; background: rgba(229, 51, 42, 0.1); padding: 2px 6px; border-radius: 3px; display: inline-block; margin-top: 2px; }
    .add-cart-btn { width: 36px; height: 36px; background: #E5332A; border: none; border-radius: 8px; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; flex-shrink: 0; }
    .add-cart-btn:hover { background: #c72a22; transform: scale(1.1); }
    .add-cart-btn.in-cart { background: #06d6a0; }
    .add-cart-btn.adding { animation: pulse-btn 0.3s; }
    @keyframes pulse-btn { 50% { transform: scale(1.2); } }
    
    /* Loading */
    .loading-skeleton { display: grid; grid-template-columns: 1fr 1.3fr; gap: 32px; padding: 28px; background: #fff; border-radius: 16px; margin: 20px 0; }
    .skeleton-image { aspect-ratio: 1; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 12px; }
    .skeleton-content { padding: 20px 0; }
    .skeleton-line { height: 20px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 6px; margin-bottom: 14px; }
    .skeleton-line.w-60 { width: 60%; }
    .skeleton-line.w-80 { width: 80%; }
    .skeleton-line.w-40 { width: 40%; }

    .media-tabs {
      display: flex;
      gap: 8px;
      margin-bottom: 12px;
      border-bottom: 2px solid #e9ecef;
    }
    
    .media-tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 18px;
      background: none;
      border: none;
      border-bottom: 3px solid transparent;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      color: #868e96;
      transition: all 0.2s;
    }
    
    .media-tab:hover {
      color: #2B2B2B;
    }
    
    .media-tab.active {
      color: #E5332A;
      border-bottom-color: #E5332A;
    }
    
    .media-tab svg {
      width: 16px;
      height: 16px;
    }
    
    /* 🆕 VİDEO CONTAINER */
    .main-video-container {
      width: 100%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .main-video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    
    /* 🆕 VİDEO THUMBNAIL */
    .thumbnail.video-thumb {
      position: relative;
    }
    
    .thumbnail.video-thumb video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      pointer-events: none;
    }
    
    .video-thumb-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.6);
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      pointer-events: none;
    }
    
    .thumbnail.video-thumb:hover .video-thumb-overlay {
      background: rgba(229, 51, 42, 0.8);
    }

    /* RESPONSIVE */
    @media (max-width: 1200px) {
      .product-carousel-item { width: calc((100% - 60px) / 4); min-width: 200px; }
      .carousel-nav-btn.left { left: -16px; }
      .carousel-nav-btn.right { right: -16px; }
    }

    @media (max-width: 992px) {
      .product-layout { grid-template-columns: 1fr; }
      .product-gallery { position: static; }
      .rating-summary { grid-template-columns: 1fr; text-align: center; }
      .rating-overview { flex-direction: column; }
      .product-carousel-item { width: calc((100% - 40px) / 3); min-width: 180px; }
      .carousel-nav-btn { width: 40px; height: 40px; }
      .carousel-nav-btn.left { left: -12px; }
      .carousel-nav-btn.right { right: -12px; }
    }

    /* 🆕 SLIDER STİLLERİ */
    .product-gallery {
      position: sticky;
      top: 100px;
    }
    
    /* Ana Slider */
    .main-image-slider {
      position: relative;
      aspect-ratio: 1;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      margin-bottom: 12px;
      border: 1px solid #e9ecef;
    }
    
    .main-image-container {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      cursor: zoom-in;
    }
    
    .main-image-container img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 16px;
      transition: transform 0.3s ease;
    }
    
    .main-image-container img.zoomed {
      cursor: zoom-out;
    }
    
    .zoom-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(transparent, rgba(0,0,0,0.7));
      color: white;
      padding: 10px;
      text-align: center;
      font-size: 12px;
      pointer-events: none;
    }
    
    .zoom-hint {
      opacity: 0.9;
      font-weight: 500;
    }
    
    /* Slider Navigasyon Butonları */
    .slider-nav-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      border: 2px solid #e9ecef;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      opacity: 0;
    }
    
    .main-image-slider:hover .slider-nav-btn {
      opacity: 1;
    }
    
    .slider-nav-btn:hover {
      background: #fff;
      border-color: #E5332A;
      box-shadow: 0 6px 20px rgba(229, 51, 42, 0.2);
    }
    
    .slider-nav-btn:active {
      transform: translateY(-50%) scale(0.95);
    }
    
    .slider-nav-btn.prev {
      left: 12px;
    }
    
    .slider-nav-btn.next {
      right: 12px;
    }
    
    .slider-nav-btn svg {
      color: #2B2B2B;
      transition: color 0.3s ease;
    }
    
    .slider-nav-btn:hover svg {
      color: #E5332A;
    }
    
    /* Slider Sayacı */
    .slider-counter {
      position: absolute;
      bottom: 12px;
      right: 12px;
      background: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      z-index: 5;
    }
    
    /* Thumbnail Slider */
    .thumbnail-slider {
      position: relative;
    }
    
    .thumbnail-scroll-container {
      display: flex;
      gap: 8px;
      overflow-x: auto;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding: 4px 0;
    }
    
    .thumbnail-scroll-container::-webkit-scrollbar {
      display: none;
    }
    
    .thumbnail {
      width: 70px;
      height: 70px;
      border: 2px solid #e9ecef;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      padding: 6px;
      background: #fff;
      transition: all 0.2s;
      flex-shrink: 0;
      position: relative;
    }
    
    .thumbnail:hover {
      border-color: #adb5bd;
    }
    
    .thumbnail.active {
      border-color: #E5332A;
    }
    
    .thumbnail img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    
    .thumbnail-active-indicator {
      position: absolute;
      bottom: 2px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 3px;
      background: #E5332A;
      border-radius: 2px;
    }
    
    /* Thumbnail Navigasyon Butonları */
    .thumbnail-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.95);
      border: 1px solid #dee2e6;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 2;
      transition: all 0.2s;
      opacity: 0;
    }
    
    .thumbnail-slider:hover .thumbnail-nav {
      opacity: 1;
    }
    
    .thumbnail-nav:hover {
      background: #fff;
      border-color: #E5332A;
      box-shadow: 0 2px 8px rgba(229, 51, 42, 0.2);
    }
    
    .thumbnail-nav.prev {
      left: -14px;
    }
    
    .thumbnail-nav.next {
      right: -14px;
    }
    
    .thumbnail-nav svg {
      width: 14px;
      height: 14px;
      color: #495057;
    }
    
    .thumbnail-nav:hover svg {
      color: #E5332A;
    }
    
    /* Dokunmatik için mobil optimizasyonu */
    @media (hover: none) and (pointer: coarse) {
      .slider-nav-btn {
        opacity: 1;
        width: 36px;
        height: 36px;
      }
      
      .slider-nav-btn svg {
        width: 18px;
        height: 18px;
      }
      
      .thumbnail-nav {
        opacity: 1;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 2px 6px rgba(0,0,0,0.15);
      }
      
      .main-image-container {
        cursor: default;
      }
      
      .main-image-container img.zoomed {
        cursor: default;
        transform: none !important;
      }

      .media-tabs {
        gap: 6px;
        margin-bottom: 10px;
      }
      
      .media-tab {
        padding: 8px 14px;
        font-size: 12px;
      }
      
      .media-tab svg {
        width: 14px;
        height: 14px;
      }
      
      .video-thumb-overlay {
        width: 28px;
        height: 28px;
      }
      
      .video-thumb-overlay svg {
        width: 16px;
        height: 16px;
      }
    }

    @media (max-width: 768px) {
  .container { 
    padding: 0 16px; 
  }
  
  /* Breadcrumb */
  .breadcrumb {
    font-size: 12px;
    margin: 16px 0;
    gap: 4px;
  }
  
  .breadcrumb svg {
    width: 12px;
    height: 12px;
  }
  
  /* Product Layout */
  .product-layout { 
    grid-template-columns: 1fr; 
    padding: 20px 16px;
    gap: 24px;
  }
  
  .product-gallery { 
    position: static; 
  }
  
  /* Gallery */
  .main-image {
    margin-bottom: 10px;
  }
  
  .thumbnail {
    width: 60px;
    height: 60px;
  }
  
  /* Product Info */
  .category-tag {
    font-size: 10px;
    padding: 3px 8px;
  }
  
  .product-info h1 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  /* Rating */
  .rating-row {
    margin-bottom: 12px;
  }
  
  .stars svg {
    width: 16px;
    height: 16px;
  }
  
  .rating-value {
    font-size: 14px;
  }
  
  .reviews-link {
    font-size: 13px;
  }
  
  .no-rating-text {
    font-size: 13px;
  }
  
  /* Price */
  .price-section {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
  
  .original-price {
    font-size: 15px;
  }
  
  .current-price {
    font-size: 24px;
  }
  
  .save-amount {
    font-size: 11px;
    padding: 3px 8px;
  }
  
  /* Offers */
  .offers-section {
    padding: 16px;
    margin-bottom: 20px;
  }
  
  .offers-section > h3 {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .offer-card {
    padding: 12px;
  }
  
  .offer-badge {
    font-size: 9px;
    padding: 4px 8px;
  }
  
  .offer-discount {
    font-size: 18px;
  }
  
  .offer-body h4 {
    font-size: 13px;
  }
  
  .offer-body p {
    font-size: 12px;
  }
  
  .offer-condition,
  .offer-applied {
    font-size: 11px;
    padding: 6px 8px;
  }
  
  /* Actions */
  .actions-section {
    margin-bottom: 20px;
  }
  
  .quantity-selector {
    margin-bottom: 14px;
  }
  
  .quantity-selector > span {
    font-size: 13px;
  }
  
  .quantity-controls button {
    width: 36px;
    height: 36px;
  }
  
  .quantity-controls > span {
    width: 36px;
    font-size: 15px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 8px;
  }
  
  .add-to-cart-btn,
  .buy-now-btn {
    padding: 12px 16px;
    font-size: 13px;
  }
  
  .secondary-actions {
    gap: 8px;
  }
  
  .secondary-actions .wishlist-btn,
  .secondary-actions .share-btn {
    font-size: 12px;
    padding: 8px;
  }
  
  /* Features */
  .features-list {
    padding: 16px;
    gap: 10px;
  }
  
  .feature svg {
    width: 16px;
    height: 16px;
  }
  
  .feature strong {
    font-size: 12px;
  }
  
  .feature span {
    font-size: 11px;
  }
  
  /* Product Details Section */
  .product-details-section { 
    padding: 20px 16px;
    margin-bottom: 24px;
  }
  
  .details-tabs { 
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    gap: 0;
    margin-bottom: 20px;
  }
  
  .details-tabs::-webkit-scrollbar {
    display: none;
  }
  
  .details-tabs .tab { 
    padding: 12px 16px; 
    font-size: 13px; 
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .details-content {
    min-height: 250px;
  }
  
  .description-tab h3,
  .specs-tab h3 {
    font-size: 16px;
    margin-bottom: 14px;
  }
  
  .description-tab p {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .specs-table td {
    padding: 12px 10px;
    font-size: 13px;
  }
  
  .specs-table td:first-child {
    width: 35%;
  }
  
  /* Reviews */
  .rating-summary { 
    grid-template-columns: 1fr;
    padding: 20px 16px;
    gap: 24px;
  }
  
  .rating-overview {
    flex-direction: column;
    gap: 20px;
  }
  
  .score-number {
    font-size: 42px;
  }
  
  .stars-large svg {
    width: 20px;
    height: 20px;
  }
  
  .rating-count {
    font-size: 13px;
  }
  
  .rating-bar {
    gap: 10px;
  }
  
  .star-label {
    min-width: 45px;
    font-size: 13px;
  }
  
  .bar-count {
    min-width: 35px;
    font-size: 12px;
  }
  
  .reviews-filters { 
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-bottom: 20px;
  }
  
  .reviews-filters::-webkit-scrollbar {
    display: none;
  }
  
  .filter-buttons { 
    flex-wrap: nowrap;
    gap: 6px;
  }
  
  .filter-btn {
    padding: 7px 14px;
    font-size: 12px;
    flex-shrink: 0;
    white-space: nowrap;
  }
  
  .filter-btn svg {
    width: 11px;
    height: 11px;
  }
  
  /* Review Card */
  .review-card {
    padding: 16px;
  }
  
  .avatar {
    width: 42px;
    height: 42px;
    font-size: 18px;
  }
  
  .reviewer-name {
    font-size: 14px;
  }
  
  .verified-badge {
    font-size: 10px;
    padding: 2px 6px;
  }
  
  .verified-badge svg {
    width: 10px;
    height: 10px;
  }
  
  .review-date {
    font-size: 12px;
  }
  
  .review-title {
    font-size: 15px;
  }
  
  .review-comment {
    font-size: 13px;
  }
  
  .review-image {
    width: 70px;
    height: 70px;
  }
  
  .helpful-btn {
    padding: 7px 14px;
    font-size: 12px;
  }
  
  .admin-reply {
    padding: 10px 14px;
  }
  
  .reply-badge {
    font-size: 11px;
  }
  
  .admin-reply p {
    font-size: 13px;
  }
  
  /* Related Products */
  .related-products {
    margin-bottom: 32px;
  }
  
  .section-header {
    margin-bottom: 24px;
  }
  
  .section-header h2 {
    font-size: 20px;
  }
  
  .section-header p {
    font-size: 13px;
  }
  
  .product-carousel-item { 
    width: calc((100% - 20px) / 2); 
    min-width: 160px;
    height: 340px;
  }
  
  .carousel-nav-btn { 
    display: none; 
  }
  
  .products-carousel { 
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    gap: 12px;
  }
  
  .product-carousel-item {
    scroll-snap-align: start;
  }
  
  /* Loading Skeleton */
  .loading-skeleton {
    grid-template-columns: 1fr;
    padding: 20px 16px;
    gap: 20px;
  }

  .slider-nav-btn {
        width: 36px;
        height: 36px;
        opacity: 1;
      }
      
      .slider-nav-btn svg {
        width: 18px;
        height: 18px;
      }
      
      .slider-counter {
        font-size: 11px;
        padding: 3px 10px;
      }
      
      .thumbnail {
        width: 60px;
        height: 60px;
      }
      
      .thumbnail-nav {
        opacity: 1;
        width: 24px;
        height: 24px;
      }
      
      .thumbnail-nav.prev {
        left: -12px;
      }
      
      .thumbnail-nav.next {
        right: -12px;
      }
}

/* 480px - KÜÇÜK MOBİL için ek optimizasyonlar */
@media (max-width: 480px) {
  .container {
    padding: 0 12px;
  }
  
  /* Breadcrumb */
  .breadcrumb {
    font-size: 11px;
    margin: 12px 0;
  }
  
  /* Product Layout */
  .product-layout {
    padding: 16px 12px;
    gap: 20px;
  }
  
  /* Gallery */
  .thumbnail {
    width: 50px;
    height: 50px;
    padding: 4px;
  }
  
  .discount-badge {
    font-size: 11px;
    padding: 4px 10px;
    top: 10px;
    left: 10px;
  }
  
  /* Product Info */
  .product-info h1 {
    font-size: 16px;
  }
  
  .rating-row {
    gap: 8px;
  }
  
  .stars svg {
    width: 14px;
    height: 14px;
  }
  
  .rating-value {
    font-size: 13px;
  }
  
  .reviews-link {
    font-size: 12px;
  }
  
  /* Price */
  .original-price {
    font-size: 14px;
  }
  
  .current-price {
    font-size: 20px;
  }
  
  .save-amount {
    font-size: 10px;
  }
  
  /* Offers */
  .offers-section {
    padding: 14px;
  }
  
  .offers-section > h3 {
    font-size: 13px;
  }
  
  .offer-card {
    padding: 10px;
  }
  
  .offer-discount {
    font-size: 16px;
  }
  
  .offer-body h4 {
    font-size: 12px;
  }
  
  .offer-body p {
    font-size: 11px;
  }
  
  /* Actions */
  .quantity-controls button {
    width: 32px;
    height: 32px;
  }
  
  .quantity-controls > span {
    width: 32px;
    font-size: 14px;
  }
  
  .add-to-cart-btn,
  .buy-now-btn {
    padding: 10px 14px;
    font-size: 12px;
    gap: 6px;
  }
  
  .add-to-cart-btn svg,
  .buy-now-btn svg {
    width: 16px;
    height: 16px;
  }
  
  .secondary-actions .wishlist-btn,
  .secondary-actions .share-btn {
    font-size: 11px;
    padding: 7px;
    gap: 4px;
  }
  
  .secondary-actions svg {
    width: 16px;
    height: 16px;
  }
  
  /* Features */
  .features-list {
    padding: 14px;
  }
  
  .feature svg {
    width: 14px;
    height: 14px;
  }
  
  .feature strong {
    font-size: 11px;
  }
  
  .feature span {
    font-size: 10px;
  }
  
  /* Product Details */
  .product-details-section {
    padding: 16px 12px;
  }
  
  .details-tabs .tab {
    padding: 10px 14px;
    font-size: 12px;
  }
  
  .description-tab h3,
  .specs-tab h3 {
    font-size: 15px;
  }
  
  .description-tab p {
    font-size: 13px;
  }
  
  .specs-table td {
    padding: 10px 8px;
    font-size: 12px;
  }
  
  /* Reviews */
  .rating-summary {
    padding: 16px 12px;
  }
  
  .score-number { 
    font-size: 36px; 
  }
  
  .stars-large { 
    gap: 2px; 
  }
  
  .stars-large svg {
    width: 18px;
    height: 18px;
  }
  
  .rating-count {
    font-size: 12px;
  }
  
  .star-label {
    min-width: 40px;
    font-size: 12px;
  }
  
  .bar-container {
    height: 6px;
  }
  
  .bar-count {
    font-size: 11px;
  }
  
  .filter-btn {
    padding: 6px 12px;
    font-size: 11px;
  }
  
  /* Review Card */
  .review-card {
    padding: 14px;
  }
  
  .avatar {
    width: 38px;
    height: 38px;
    font-size: 16px;
  }
  
  .reviewer-name {
    font-size: 13px;
  }
  
  .review-date {
    font-size: 11px;
  }
  
  .review-title {
    font-size: 14px;
  }
  
  .review-comment {
    font-size: 12px;
  }
  
  .review-image {
    width: 60px;
    height: 60px;
  }
  
  .helpful-btn {
    padding: 6px 12px;
    font-size: 11px;
  }
  
  .admin-reply {
    padding: 8px 12px;
  }
  
  .admin-reply p {
    font-size: 12px;
  }
  
  /* No Reviews */
  .no-reviews-simple {
    padding: 40px 16px;
  }
  
  .no-reviews-simple svg {
    width: 40px;
    height: 40px;
  }
  
  .no-reviews-simple h3 {
    font-size: 18px;
  }
  
  .no-reviews-simple p {
    font-size: 14px;
  }
  
  /* Related Products */
  .section-header h2 {
    font-size: 18px;
  }
  
  .section-header p {
    font-size: 12px;
  }
  
  .product-carousel-item {
    width: calc((100% - 12px) / 2);
    min-width: 145px;
    height: 320px;
  }
  
  .products-carousel {
    gap: 8px;
  }
  
  /* Loading */
  .loading-skeleton {
    padding: 16px 12px;
  }
}

/* 360px - ÇOK KÜÇÜK MOBİL */
@media (max-width: 360px) {
  .container {
    padding: 0 10px;
  }
  
  .product-layout {
    padding: 14px 10px;
  }
  
  .product-info h1 {
    font-size: 15px;
  }
  
  .current-price {
    font-size: 18px;
  }
  
  .thumbnail {
    width: 45px;
    height: 45px;
  }
  
  .quantity-controls button {
    width: 28px;
    height: 28px;
  }
  
  .quantity-controls > span {
    width: 28px;
    font-size: 13px;
  }
  
  .add-to-cart-btn,
  .buy-now-btn {
    font-size: 11px;
    padding: 9px 12px;
  }
  
  .product-details-section {
    padding: 14px 10px;
  }
  
  .details-tabs .tab {
    padding: 9px 12px;
    font-size: 11px;
  }
  
  .rating-summary {
    padding: 14px 10px;
  }
  
  .score-number {
    font-size: 32px;
  }
  
  .review-card {
    padding: 12px;
  }
  
  .product-carousel-item {
    width: calc((100% - 8px) / 2);
    min-width: 135px;
    height: 300px;
  }
  `}</style>;
}